import { Cls, Emojis } from 'app/constants';
import { useAppSelector } from 'app/hooks';
import { getSelectedGame } from 'app/slices/GamesSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

export const GameDetailsIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const selectedGameId = useAppSelector(getSelectedGame);

  useEffect(() => {
    if (!selectedGameId) {
      const msg = `${Emojis.eyes} %c GameDetailsIndexRoute %c, no %c selectedGameId %c`;
      console.log(msg, Cls.Loc, '', Cls.Cri, '');
      navigate(AppRoutes.WeeklyGames);
    }
  }, [selectedGameId, navigate]);

  return <></>;
};

export default GameDetailsIndexRoute;
